import {z} from "zod"
import {evaluatingTo} from "#graph/nodes/graph/validation"

export const ListDefinition = <ItemType>(itemSchema: z.ZodType<ItemType>) => ({
    validation: {
        returns: z.array(itemSchema),
        parameters: z.object({list: z.array(evaluatingTo(itemSchema))}),
    },
})
